module.exports = __webpack_public_path__ + "img/pic_1@2x.0838732d.png";